export default __webpack_public_path__ + "static/1-019e35d62b6a59b1436d8caa18b6275f.webp";